<app-ship-details
  *ngIf="ship"
  [shipData]="ship"
  [shipResultArray]="shipResultArray"
  (newShipSelectedEmitter)="onShipChange($event)">
</app-ship-details>

<div class="card card-nc" *ngIf="hasEntitlement('SHIPS_HULLSWAP_SWAP')">
  <div class="card-heading">
    <i class="fa fa-ship"></i>
    <span class="cardHeaderHeading"> Hull Swap </span>
    <span class="pull-right save-panel">
        <span [class]="stripSwapSuccessFail">
          <span [class]="stripSwapCircle">
          </span>&nbsp;&nbsp;{{stripSwapStatus}}
        </span>&nbsp;
        <button
          *ngIf="hasEntitlement('SHIPS_ROUNDTRIPS_UPDATE')"
          type="submit"
          [disabled]="hasFormError"
          (click)="hullSwapShips()"
          class="btn btn-nc">
          SWAP NOW <i [ngClass]="swap_btn_spinner"></i>
        </button>
    </span>
  </div>
  <div class="card-body" *ngIf="shipProfiles">
    <form name="shipSwapForm" [formGroup]="shipSwapForm">
      <div class="row">
        <div class="col-md-8">
          <div class="row">
            <div class="col-md-2">
              <img src="../../assets/img/NAVY.png">
            </div>
            <div class="col-md-7 rightLeftPad">
              <span class="labelCommon">From Ship</span><br>
              <span class="pageTitleText">{{ship.shipName}} ({{ship.shipHull}})</span><br>
              <span class="loginScreenLabels">
              {{ship.shipLocation}} / {{ ship.isDecommissioned === 'N' ? 'Commissioned' : 'Decommissioned' }}
            </span>
            </div>
            <div class="col-md-1" style="padding-top: 23px;">
              <i class="fa fa-long-arrow-right fa-2x" style="color: #555555"></i>
            </div>
          </div>
        </div>
        <div class="col-md-3" *ngIf="shipProfiles">
          <span class="labelCommon">To Ship</span>
          <select
            class="form-control input-sm"
            formControlName="desShip"
            [style.border]="hasFormError ? '1px solid red' : ''"
            id="desShip">
            <option [ngValue]="undefined" selected>Please Select...</option>
            <option
              *ngFor="let shipProfile of shipProfiles"
              [value]="shipProfile.shipLocation">{{shipProfile.shipName}}
            </option>
          </select>
          <div class="help-block has-error validationMessage" *ngIf="hasFormError && hasSameShip">
            Source and Destination ships are the same. Please re-select.
          </div>
          <div class="help-block has-error validationMessage" *ngIf="hasFormError && !hasSameShip">
            Selection Required
          </div>
        </div>
      </div>
    </form>
  </div>
</div>

